/* eslint-disable no-unused-vars */
import ApiService from "../../api.service";
import appConfig from "../../../../app-config";
import { TokenStorage } from "../../../storage";

ApiService.init(appConfig.VUE_APP_ROOT_API);

const ProductCategory2Service = {
  /**
   * Get Screen data
   *
   * */
  async getByCode(code) {
    const requestScreenData = {
      url: "api/ProductCategory2",
      top: "1",
      filter: `Code eq '${code}'`,
    };

    return await ApiService.oDataGet(requestScreenData);
  },
  dataSourceConfig(url, params) {
    return ApiService.createDataSource(url, params);
  },
  async save(mode, ProductCategory2) {
    var payload = ProductCategory2;
    var url = "api/Save_ProductCategory2";

    if (mode == "create") {
      return await ApiService.post(url, payload, "String");
    } else {
      return await ApiService.put(
        url,
        ProductCategory2.Code,
        payload,
        "String"
      );
    }
  },
  async saveOld(mode, ProductCategory2) {
    var payload = ProductCategory2;
    var url = "api/ProductCategory2";

    if (mode == "create") {
      return await ApiService.post(url, payload, "String");
    } else {
      return await ApiService.patch(
        url,
        ProductCategory2.Code,
        payload,
        "String"
      );
    }
  },
};

export { ProductCategory2Service };
